import { Pipe, PipeTransform } from "@angular/core";
import { isStringNullOrEmpty } from "@globals/helper-functions";
import { PhoneNumberTypeEnum } from "@globals/openapi-models/model/phoneNumberTypeEnum";
import { SubscriptionDto } from "@globals/openapi-models/model/subscriptionDto";

@Pipe({ name: "subscriptionToIcon", standalone: true })
export class SubscriptionToIconPipe implements PipeTransform {
  transform(subscription: SubscriptionDto): string {
    if (subscription.phoneNumber) {
      if (subscription.smsSubscription || subscription.phoneNumberType === PhoneNumberTypeEnum.PhoneNormalMobile) {
        return `<span class='fa-solid fa-mobile-alt fa-2x inline-block' title='${"Mobile"}'></span>`;
      } else if (subscription.voiceSubscription || subscription.phoneNumberType === PhoneNumberTypeEnum.PhoneNormalLandLine) {
        return `<span class='fa-solid fa-phone-volume fa-2x inline-block' title="${"Landline"}"></span>`;
      }
    } else {
      if (subscription.emailSubscription || !isStringNullOrEmpty(subscription.email)) {
        return `<span class='fa-regular fa-envelope fa-2x inline-block' title="${"Email"}"></span>`;
      }
    }
    return "";
  }
}
